import { VFC } from 'hoist-non-react-statics/node_modules/@types/react'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { Button, ButtonsDiv, CancelButton, Layout } from './styles'

const RoomHiding: VFC<ModalProps<{ hide: () => Promise<any> }>> = ({
  hide,
  close,
}) => (
  <Layout>
    <h3>このルームを非表示にしますか？</h3>
    <p>非表示にしたルームは「非表示」に分類されます</p>
    <ButtonsDiv>
      <CancelButton onClick={close}>キャンセル</CancelButton>
      <Button
        onClick={async () => {
          await hide()
          close()
        }}
      >
        非表示
      </Button>
    </ButtonsDiv>
  </Layout>
)

export const RoomHidingModal = asModal(RoomHiding)
